// removed by extract-text-webpack-plugin
module.exports = {"popupFooter":"src-scripts-components-PopupFooter-__popupFooter___popupFooter","small":"src-scripts-components-PopupFooter-__popupFooter___small","medium":"src-scripts-components-PopupFooter-__popupFooter___medium","large":"src-scripts-components-PopupFooter-__popupFooter___large","clearPaddings":"src-scripts-components-PopupFooter-__popupFooter___clearPaddings","left":"src-scripts-components-PopupFooter-__popupFooter___left","center":"src-scripts-components-PopupFooter-__popupFooter___center","right":"src-scripts-components-PopupFooter-__popupFooter___right"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/PopupFooter/popupFooter.css
// module id = 2322
// module chunks = 0